import { Mail, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-secondary/30 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <div className="flex justify-center gap-6">
            <a
              href="mailto:ilanklimberg@gmail.com"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-200 ease-out group"
            >
              <Mail className="h-5 w-5 group-hover:scale-105 transition-transform duration-200 ease-out" />
              <span className="font-medium">ilanklimberg@gmail.com</span>
            </a>
            <a
              href="https://linkedin.com/in/ilanklimberg"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-200 ease-out group"
            >
              <Linkedin className="h-5 w-5 group-hover:scale-105 transition-transform duration-200 ease-out" />
              <span className="font-medium">linkedin.com/in/ilanklimberg</span>
            </a>
          </div>

          <div className="pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Ilan Klimberg. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
